module.exports = __webpack_public_path__ + "img/web4icon2.eaa4431e.png";